/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener('pageshow', function() {
	let overlay = document.querySelector('.PageTransition')
	if (overlay && overlay.style.opacity != 0) {
		overlay.style.opacity = 0
	}
})

// Checks if a size variant is selected
window.isSizeSelected = function(context) {
	context = context || document;
	var sizeRadios = context.querySelectorAll('.SizeSwatch__Radio');
	
	// If there are no size radios, check if it's a gift card
	if (sizeRadios.length === 0) {
		// Check for gift card value selection
		var giftCardRadios = context.querySelectorAll('.SwatchList--gift-card .Swatch__Radio');
		
		// If there are no gift card radios either, validation passes (single variant product)
		if (giftCardRadios.length === 0) {
			return true;
		}
		
		// Check if any gift card value is selected
		for (var i = 0; i < giftCardRadios.length; i++) {
			if (giftCardRadios[i].checked) {
				return true;
			}
		}
		
		// No gift card value selected
		return false;
	}
	
	// For regular products with sizes, check if size is selected
	for (var i = 0; i < sizeRadios.length; i++) {
		if (sizeRadios[i].checked) {
			return true;
		}
	}
	
	return false;
}


//  Shows the size error message
window.showSizeError = function() {
	var sizeError = document.getElementById('size-error');
	if (sizeError) {
		sizeError.classList.remove('hidden');
	}
}


// Hides the size error message
window.hideSizeError = function() {
	var sizeError = document.getElementById('size-error');
	if (sizeError) {
		sizeError.classList.add('hidden');
	}
}


// Validates size selection and shows error if needed
window.validateSizeSelection = function(event, context) {
	if (!window.isSizeSelected(context)) {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		window.showSizeError();
		return false;
	}
	return true;
}

/*============================================================================
  pdp find in store
==============================================================================*/

window.addEventListener('load', function() {

  MicroModal.init({
    openTrigger: "data-micromodal-trigger",
    closeTrigger: "data-micromodal-close",
    openClass: "is-open",
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: false,
    awaitCloseAnimation: false,
    debugMode: true,
  });


	function getReverseGeocodingData(lat, lng, input) {
		var latlng = new google.maps.LatLng(lat, lng)
		var geocoder = new google.maps.Geocoder()
		geocoder.geocode({ latLng: latlng }, (results, status) => {
			if (status !== google.maps.GeocoderStatus.OK) {
				alert(status)
			}
			if (status == google.maps.GeocoderStatus.OK) {
				input.value = results[0].address_components[4].long_name
				document.querySelector('.stockist-search-button button').click()
			}
		})
	}

	if (window.location.pathname.includes('/products/')) {
		const FindInStoreStockistObserver = new MutationObserver(function(
			mutations,
			mutationInstance
		) {
			const listResult = document.querySelector('.stockist-list-result')

			if (listResult) {
				// redefine structure as single list items can't achieve the required layout
				const directions = document.querySelectorAll('.stockist-result-directions-link')

				const distances = document.querySelectorAll('.stockist-result-distance')
				const map = document.querySelector('.stockist-map-google')
				const searchBar = document.querySelector('.stockist-query-entry')
				const searchInput = searchBar.querySelector('input')

				searchBar.insertAdjacentHTML(
					'afterend',
					'<button class="custom-search-button btn btn--full btn--dark"><span>Use my current location</span></button>'
				)

				const customSearchBtn = document.querySelector('.custom-search-button')

				customSearchBtn.addEventListener('click', function() {
					var options = {
						enableHighAccuracy: true,
						timeout: 5000,
						maximumAge: 0,
					}

					function success(pos) {
						var crd = pos.coords
						getReverseGeocodingData(crd.latitude, crd.longitude, searchInput)
					}

					function error(err) {
						console.warn(`ERROR(${err.code}): ${err.message}`)
					}

					navigator.geolocation.getCurrentPosition(success, error, options)
				})

				distances.forEach((distance) => {
					distance.remove()
				})

				map.remove()

				const allResults = document.querySelectorAll('.stockist-list-result')

				allResults.forEach((result) => {
					const currentMarkup = result.innerHTML
					const wrappedMarkup = `<div class='result-wrap'>${currentMarkup}</div>`
					result.innerHTML = `
          <div class='result-logo'></div>
          ${wrappedMarkup}
          <div class='result-quantity'>
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>`
				})

				mutationInstance.disconnect()
			}
		})

		FindInStoreStockistObserver.observe(document, {
			childList: true,
			subtree: true,
		})

	// find in store pdp button
	// calls ap21 endpoint and checks against the hidden custom field for store name
	const findInStoreSelector = document.getElementById('find-in-store')

	findInStoreSelector.addEventListener('click', function(event) {
		// Validate size selection before opening modal
		if (!window.validateSizeSelection(event)) {
			return false;
		}
	})

	// click and collect pdp button
	const clickAndCollectSelector = document.getElementById('click-and-collect-btn')

	if (clickAndCollectSelector) {
		clickAndCollectSelector.addEventListener('click', function(event) {
			// Validate size selection before opening modal
			if (!window.validateSizeSelection(event)) {
				return false;
			}
		}, true) // Use capture phase to run before MicroModal's listener
	}
}

	// Hide size error when a size is selected
	if (window.location.pathname.includes('/products/')) {
	  const sizeRadios = document.querySelectorAll('.SizeSwatch__Radio');

	  // Hide error when user selects a size
	  sizeRadios.forEach(function(radio) {
	    radio.addEventListener('change', window.hideSizeError);
	  });
	  
	  // Hide error when user selects a gift card value
	  const giftCardRadios = document.querySelectorAll('.SwatchList--gift-card .Swatch__Radio');
	  giftCardRadios.forEach(function(radio) {
	    radio.addEventListener('change', window.hideSizeError);
	  });
	}
})

// document.addEventListener('product:added', function(event) {
// 	console.log(event);
// 	console.log('Product added to cart');
// });